import apiClient, { prefetchApiCsrfToken } from "../common";

/** POST /api/v1/simulations/<id>/finalize/ — marca la simulación como completada. */
export async function apiFinalizeSimulation(simulationId: string): Promise<unknown> {
  await prefetchApiCsrfToken();
  const res = await apiClient.post(`simulations/${simulationId}/finalize/`);
  return res.data;
}
